
import { put, takeLatest } from 'redux-saga/effects';
import { APPOINTMENT_CATEGORY } from '../../../shared/constants/crmConstants';
import SendRequest from '../../../shared/services/sendRequest.service';
import actionTypes from '../../types/newAppointmentTypes';
import * as actions from '../../actions/newAppointmentAction';
import { GLOBAL_URL } from '../../../shared/constants/dataServiceUrl';

function* subCategories(data: any): Generator {
  const sendRequest = SendRequest.instance;
  const { payload } = data;
  const { city, selectedOption, getSubCategoryData } = payload;
  const appointementCategoryObj = APPOINTMENT_CATEGORY.filter((item: any): any => item.name === selectedOption);

  if (city && selectedOption) {
    const request = {
      CategoryItemTypeId: appointementCategoryObj[0].CategoryTypeId,
      City: city,
      IncludePackages: false,
      PageNo: 0,
      PageSize: 1000,
    };
    try {
      const response: any = yield sendRequest.post<any, any>
        (`${GLOBAL_URL.CRM_OUTPATIENT_URL}Provider/CategoryItemSearch`, request);
      getSubCategoryData(response);
      return;
    } catch (e) {
    }
  }
}

function* timeSlots(data: any): Generator {
  const sendRequest = SendRequest.instance;
  const { payload } = data;
  const { option } = payload;

  const request = {
    packageId: option,
    visitType: 'DiagnosticCenter',
  };
  try {
    const response: any = yield sendRequest.post<any, any>
      (`${GLOBAL_URL.CRM_OUTPATIENT_URL}Provider/FetchAvailableSlots`, request);
    if (response && response.isSuccess && response.providerSlots && response.providerSlots.length > 0) {
      yield put(actions.setTimeSlots(response.providerSlots));
    }
    return;
  } catch (e) {
  }
}

function* submitForm(data: any): Generator {
  const sendRequest = SendRequest.instance;
  const { payload } = data;
  const { emailId, fullName, mobile, subCategory, date,
  } = payload;

  const request = {
    orderItems: [
      {
        packageId: subCategory,
        patientName: fullName,
        emailId,
        mobileNumber: mobile,
      },
    ],
    additionalInformation: {
      firstAppointmentDate: date,
    },
  };
  try {
    yield sendRequest.post<any, any>
      (`${GLOBAL_URL.CRM_OUTPATIENT_URL}Provider/NewAppointment`, request);

    // if (response && response.isSuccess && response.providerSlots && response.providerSlots.length > 0) {
    //   yield put(actions.setTimeSlots(response.providerSlots));
    // }
    return;
  } catch (e) {
  }
}

export function* watchNewAppointement(): any {
  yield takeLatest(actionTypes.GET_SUB_CATEGORIES, subCategories);
  yield takeLatest(actionTypes.GET_TIME_SLOTS, timeSlots);
  yield takeLatest(actionTypes.SUBMIT_FORM, submitForm);
}

export default watchNewAppointement;
